import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Load third-party accessibility/widget script after initial render to reduce layout thrashing.
(() => {
  const MAGIXITE_SRC = "//acc.magixite.com/license/la?litk=ow93pk8ksm";

  const load = () => {
    if (document.querySelector(`script[data-magixite="true"]`)) return;

    const s = document.createElement("script");
    s.type = "text/javascript";
    s.src = MAGIXITE_SRC;
    s.async = true;
    s.setAttribute("data-magixite", "true");
    document.body.appendChild(s);
  };

  window.addEventListener(
    "load",
    () => {
      const ric = (window as any).requestIdleCallback as
        | ((cb: () => void, opts?: { timeout?: number }) => void)
        | undefined;

      if (ric) {
        ric(load, { timeout: 5000 });
      } else {
        window.setTimeout(load, 2500);
      }
    },
    { once: true }
  );
})();

